import { Button, Form, Input } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import { REGEX_COMMON } from 'src/shared/common/regex';

interface ISMSFormProps {
  phoneNumber: string;
  loading: boolean;
  onPhoneNumberChange: (value: string) => void;
  onSubmit: () => void;
  onBack: () => void;
}

export const SMSForm = ({
  phoneNumber,
  loading,
  onPhoneNumberChange,
  onSubmit,
  onBack,
}: ISMSFormProps) => {
  const [form] = Form.useForm();

  const handleFinish = () => {
    onSubmit();
  };

  return (
    <div className='w-full'>
      <div className='mb-6 text-center'>
        <p className='text-gray-600 text-sm'>
          Vui lòng nhập Số điện thoại để nhận mã cài đặt lại mật khẩu qua SMS
        </p>
      </div>

      <Form form={form} layout='vertical' onFinish={handleFinish}>
        <Form.Item
          label='Số điện thoại'
          name='phoneNumber'
          initialValue={phoneNumber}
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập số điện thoại',
            },
            {
              pattern: REGEX_COMMON.vietNamPhoneNumber,
              message: 'Số điện thoại không đúng định dạng',
            },
          ]}
        >
          <Input
            prefix={<PhoneOutlined className='text-gray-400' />}
            placeholder='0xxxxxxxxx'
            size='large'
            maxLength={10}
            value={phoneNumber}
            onChange={(e) => onPhoneNumberChange(e.target.value)}
          />
        </Form.Item>

        <Form.Item className='mb-4'>
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            loading={loading}
            className='w-full bg-[#1677ff]'
          >
            Tiếp tục
          </Button>
        </Form.Item>

        <Form.Item className='mb-0'>
          <Button type='link' onClick={onBack} className='w-full text-gray-600'>
            Quay lại đăng nhập
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
